const MESSAGE_SOUND_URL = '/sounds/message-sound-effect.mp3';

let audio: HTMLAudioElement | null = null;
let unlockListenerAttached = false;

function getMessageAudio(): HTMLAudioElement | null {
  if (typeof window === 'undefined') return null;
  if (!audio) {
    audio = new Audio(MESSAGE_SOUND_URL);
    audio.preload = 'auto';
  }
  return audio;
}

function attachAudioUnlockListeners(): void {
  if (unlockListenerAttached || typeof document === 'undefined') return;
  unlockListenerAttached = true;
  const unlock = () => {
    const el = getMessageAudio();
    if (!el) return;
    el.muted = true;
    void el.play().then(() => {
      el.pause();
      el.currentTime = 0;
      el.muted = false;
    }).catch(() => {
      el.muted = false;
    });
  };
  document.addEventListener('pointerdown', unlock, { once: true, passive: true });
  document.addEventListener('keydown', unlock, { once: true });
}

/** Plays the inbound message sound from `public/sounds/message-sound-effect.mp3`. */
export function playMessageSound(): void {
  attachAudioUnlockListeners();
  const el = getMessageAudio();
  if (!el) return;
  el.currentTime = 0;
  void el.play().catch(() => {
    // Browser may block until user gesture.
  });
}
